export default __webpack_public_path__ + "static/media/resume.152c9266.jpg";